module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [_c('div', {
    staticClass: "page page-rating"
  }, [_c('ul', {
    staticClass: "grid-lines-wrapper"
  }, [_c('li', {
    staticClass: "grid-line line-0"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-1"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-2"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-3"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-4"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "text-wrapper"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("РЕЙТИНГ")])])]), _vm._v(" "), _c('ul', {
    staticClass: "weeks-list",
    class: {
      collapse: _vm.showInnerWeek
    }
  }, _vm._l((_vm.weeks), function(item) {
    return _c('li', {
      staticClass: "weeks-item",
      class: {
        active: item.id <= _vm.currentWeek, current: item.id === _vm.currentWeek
      }
    }, [(item.id <= _vm.currentWeek) ? _c('a', {
      staticClass: "item-content item-link",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showWeek($event, ("/rating/" + (item.id)))
        }
      }
    }, [_c('div', {
      staticClass: "item-wrapper"
    }, [_c('h3', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])]) : _c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-wrapper"
    }, [_c('h3', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-364a4904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Rating.vue
// module id = 497
// module chunks = 1